import React from 'react';

const EmailIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width={33}
    height={25}
    viewBox="0 0 33 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30.9846 24.152L21.5679 12.788L17.8318 15.416C17.0304 15.98 15.9579 15.98 15.1446 15.416L11.4204 12.788L2.08607 24.188C2.53393 24.392 3.02893 24.5 3.53571 24.5H29.4643C29.9946 24.5 30.5132 24.38 30.9846 24.152ZM9.4875 11.42L0 4.724V20.9C0 21.476 0.129643 22.028 0.377143 22.532L9.4875 11.42ZM33 4.724L23.5243 11.408L32.6582 22.448C32.8821 21.968 33 21.44 33 20.9V4.724ZM0.542143 2.192L16.5 13.448L32.4579 2.192C32.3164 1.964 32.1514 1.748 31.9629 1.556C31.3029 0.884 30.3954 0.5 29.4643 0.5H3.53571C2.59286 0.5 1.69714 0.884 1.03714 1.556C0.848571 1.748 0.683571 1.964 0.542143 2.192Z"
      fill="#0A3887"
    />
  </svg>
);

export default EmailIcon;
